export default {
  AWAY_TEAM: "Away Team",
  CHECK_YOUR_MIC: "Check mic is working",
  DONE: "Done",
  START: "Start",
  LIVE: "LIVE",
  MUTE: "Mute",
  UNMUTE: "Unmute",
  NEXT: "Next",
  PREV: "Prev",
  SELECT_MIC: "Please select the mic",
  NO_MICS_FOUND: "No mics were found",
  STOP: "Stop",
  HOME: "Home",
  AWAY: "Away",
  CONNECT_MIC_TEXT:
    "Please connect your headset, \n" +
    "and put it on properly.\n" +
    "When you are ready, click next ",
  STARTING_BROADCAST: "Starting broadcast",
  EXIT_COMMENTARY: "Exit commentary",
  BROADCAST_ERROR_MESSAGE: "Broadcast failed to start",
  CONNECTION_ERROR_MESSAGE: "Something went wrong, reload page.",
  MISSING_TOKEN_ERROR_MESSAGE: "Invite token is missing.",
  IS_VALID_INVITE: "Make sure invite is valid",
  APPROVE_MIC: "Please allow microphone access",
  SHOW_ME_HOW: "Show me how",
  LOADING: "LOADING...",
  POWERED_BY: "Powered by",
  OPEN_IN_SAFARI: "Please open link in IOS safari"
};
